export * from '@primeuix/themes/lara/splitter';
export { default } from '@primeuix/themes/lara/splitter';
